import { useState, useMemo } from 'react';

const useFilterTags = (   ) => {
     
    const [ tags, setTags ] = useState( [] );
    
    const setFilterTags = ( items ) => {

        if ( items && items.length > 0 ) {
            const newTags = items.map( i => {
                return {
                    key: i.id,
                    title: 'Filter',
                    name: i.name,
                    onClickCallback: i.onClickCallback
                };
            } );

            setTags( newTags );

        } else {
            setTags( [] );
        }
    };

    return useMemo( () => {
        return {
            filterTags: tags,
            setFilterTags
        };
    }, [ tags ] );
};

export default useFilterTags;
